import React, { SetStateAction, useEffect, useState, Dispatch } from 'react';

const PINInputs = ({ submitFunc, resetValues, formId, setPinInputValues, className }: { submitFunc: Function, resetValues: boolean, formId: string, setPinInputValues: Dispatch<SetStateAction<string>>, className?: string }) => {
  const [inputField, setInputField] = useState({
    'pin-input-1': '',
    'pin-input-2': '',
    'pin-input-3': '',
    'pin-input-4': '',
  });
  const [pasted, setPasted] = useState(false);

  useEffect(() => {
    if (resetValues) {
      setInputField({
        'pin-input-1': '',
        'pin-input-2': '',
        'pin-input-3': '',
        'pin-input-4': '',
      })
    }
  }, [resetValues])

  /** 
   * When inputField changes, update pinInputValues with the concatenated values of the input fields to parent component
   */
  useEffect(() => {
    const values = Object.values(inputField).join('');
    setPinInputValues(values);
  }, [inputField]);

  const handleChange = (e) => {
    // When pasting in code, onChange event is fired, causing issue with input that was focused being overwritten 
    if (!pasted) {
      // Only allow numbers
      let value = e.target.value.replace(/\D/g, '');
      // If e.target.value is different than current inputValue, change input value
      value = value.replace(inputField[e.target.name], '');
      setInputField({ ...inputField, [e.target.name]: value });

      // If value has been entered and element has sibling, move focus to next sibling
      if (value.length === 1) {
        const currentEl = document.querySelector(`#${(e.target as HTMLInputElement).id}`);
        const nextSibling = currentEl?.nextElementSibling as HTMLInputElement | null;

        if (nextSibling) {
          nextSibling.focus();
        }
      }
    }

    // Set pasted variable to false, to allow user to manually input code again
    setPasted(false);
  }

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Backspace' && (e.target as HTMLInputElement).value === '') {
      const currentEl = document.querySelector(`#${(e.target as HTMLInputElement).id}`);
      const prevSibling = currentEl?.previousElementSibling?.previousElementSibling as HTMLInputElement | null;

      if (prevSibling) {
        prevSibling.focus();
      }
    }

    if (e.key === 'Enter') {
      if ((e.target as HTMLInputElement).name === 'pin-input-4' && inputField['pin-input-4'].length === 1) {
        e.preventDefault();
        handleSubmit(e);
      }
    }
  }

  const handlePaste = (e) => {
    const text = e.clipboardData.getData('text/plain');
    const splitText = text.split('');

    setInputField({
      'pin-input-1': splitText[0].replace(/\D/g, '') || '',
      'pin-input-2': splitText[1].replace(/\D/g, '') || '',
      'pin-input-3': splitText[2].replace(/\D/g, '') || '',
      'pin-input-4': splitText[3].replace(/\D/g, '') || '',
    });

    // When pasting in code, onChange event is fired, causing issue with input that was focused being overwritten
    setPasted(true);
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    const values = Object.values(inputField).join('');
    await submitFunc(values);
  }

  return (
    <form className={`pin-inputs ${className}`} name={formId} onSubmit={handleSubmit} id={formId}>
      <label htmlFor="pin-input-1" className='sr-only'>PIN Input 1</label>
      <input id="pin-input-1" name="pin-input-1" type="number" onPaste={handlePaste} onKeyDown={handleKeyDown} onChange={handleChange} value={inputField['pin-input-1']} />
      <label htmlFor="pin-input-2" className='sr-only'>PIN Input 2</label>
      <input id="pin-input-2" name="pin-input-2" type="number" onPaste={handlePaste} onKeyDown={handleKeyDown} onChange={handleChange} value={inputField['pin-input-2']} />
      <label htmlFor="pin-input-3" className='sr-only'>PIN Input 3</label>
      <input id="pin-input-3" name="pin-input-3" type="number" onPaste={handlePaste} onKeyDown={handleKeyDown} onChange={handleChange} value={inputField['pin-input-3']} />
      <label htmlFor="pin-input-4" className='sr-only'>PIN Input 4</label>
      <input id="pin-input-4" name="pin-input-4" type="number" onPaste={handlePaste} onKeyDown={handleKeyDown} onChange={handleChange} value={inputField['pin-input-4']} />

    </form>
  );
}

export default PINInputs;